var map = {
	"./AlooBhindi.jpeg": 5369,
	"./BhindiPyaz.jpeg": 3317,
	"./ChanaMasala.jpeg": 44,
	"./FriedRice.jpeg": 1600,
	"./Pizza.jpeg": 3595,
	"./SoyaChilli.jpeg": 3716,
	"./VeggiWraps.jpeg": 8906,
	"./aloosabji.jpeg": 3943,
	"./soojiUttapam.jpeg": 9321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3351;